import React from 'react'
import ReactDOM from 'react-dom'
import TrialExpiredStyle from './css/TrialExpiredFormStyle.jsx'

function TrialExpiredForm({ c_id }) {
    return (
        <React.Fragment>
            <div className="trial-form-container">
                <div className="form-content-wrapper">
                    <div>Trial has expired!</div>
                    <br />
                    {/* <div><a href={`https://npos.vercel.app/subscribe?ci=${c_id}&pn=2`}>Please register to continue to use the system. You can choose in our prepared plans that will fit your needs.</a></div> */}
                    <div><a href={`${process.env.REACT_APP_API_HOST}/subscribe?ci=${c_id}&pn=2`}>Please register to continue to use the system. You can choose in our prepared plans that will fit your needs.</a></div>
                </div>
                <div className="button-container">
                    <button
                        className="pospro-action-btn"
                        onClick={() => ReactDOM.unmountComponentAtNode(document.getElementById("modal-form-container"))}>
                        Close
                    </button>
                </div>
            </div>
            <TrialExpiredStyle />
        </React.Fragment>
    )
}

export default React.memo(TrialExpiredForm)